<template>
  <!-- Example split danger button -->
<div class="btn-group">
      <button v-if="primaryButtonDetails.conditionEvalCallback(explorerComponentThis)" @click="validateAttachedFiles()" type="button" :style="buttonStyles?buttonStyles:''" class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" d="dropdownMenuButton">
        <span class="visually-hidden" style="display: flex;align-items: center;gap: 6px;"><span v-html="primaryButtonDetails.svgIcon()"></span>{{$t(primaryButtonDetails.reviewButtonName)}}</span>
      </button>
      <ul v-if="getRegisteredCreateReviewButtons.length > 1" class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <template v-for="(button, index) in getRegisteredCreateReviewButtons.slice(1)" >
          <li 
            v-if="button.conditionEvalCallback(explorerComponentThis)"
            :key="index"
          >
            <a 
              class="dropdown-item" 
              @click="button.callback(button,explorerComponentThis)"
            >
              {{ $t(button.reviewButtonName) }}
            </a>
          </li>
        </template>
      </ul>
      <CustomMessage v-if="enableCustomMessage" v-bind="currentProperties" @close="enableCustomMessage = false"></CustomMessage>
  </div>
  </template>


  <script>
  import {mapGetters} from "vuex";
  import Utils from '../../components.utils';
  import CustomMessage from "../actions/customAlertMessage.vue"
  
  export default {
    props: ['attachmentsData','alreadyAttachedFiles','buttonStyles'],
    components:{CustomMessage},
    data() {
      return {
        primaryButtonDetails:{},
        explorerComponentThis:null,
        enableCustomMessage: false,
      }
    },
    computed: {
      ...mapGetters("registry", ['getRegisteredCreateReviewButtons']),
      ...mapGetters("users", ["getLoggedInUserPrivilege"]),
      getAttachmentsData() {
        let allAttachments = [];
        if(this.attachmentsData && this.attachmentsData.length > 0 && this.alreadyAttachedFiles && this.alreadyAttachedFiles.length > 0) {
          allAttachments = [...this.attachmentsData, ...this.alreadyAttachedFiles];
        } else if(this.attachmentsData && this.attachmentsData.length > 0) {
          allAttachments = [...this.attachmentsData];
        } else if(this.alreadyAttachedFiles && this.alreadyAttachedFiles.length > 0) {
          allAttachments = [...this.alreadyAttachedFiles];
        }
        return allAttachments;  
      },
      currentProperties() {
         return {messageType: "",
                messageTitle:"Error",
                displayMessage:"Reviews are not supported for catalogs. Please attach atleast one file to create review.",
                getUserConfirmation:false}
      },
    },
    methods: {
      isEnabled(priv){
        return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege,priv)
      },
      validateAttachedFiles(){
        let filesList = this.getAttachmentsData;
        if(filesList){
          let catalogsCount = filesList.filter(op=>'asset_type' in op && op.asset_type == 'catalog').length;
          if (catalogsCount == filesList.length){
            this.enableCustomMessage = true;
          return;
          }
        }
        this.primaryButtonDetails.callback(this.primaryButtonDetails,this.explorerComponentThis);
      }
    },
    created() {
      this.explorerComponentThis = this;
      this.primaryButtonDetails = this.getRegisteredCreateReviewButtons[0];
    },
  }
  </script>